import React from 'react'

export default function ReleaseHeader() {
  return (
    <div className="horizontal form-column-container header">
      <div className="column-flex vertical">
        <h2 className="draft">
          Online-Version
        </h2>
      </div>
      <div className="column-flex vertical">
        <h2 className="live">
          Neue-Version
        </h2>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/release/components/ReleaseHeader.js